const state = {
  sizeRecommendationDisplayable: false
};

const mutations = {
  SET_SIZE_RECOMMENDATION_DISPLAYABLE(state, sizeRecommendationDisplayable) {
    state.sizeRecommendationDisplayable = sizeRecommendationDisplayable;
  }
};

const actions = {
  fetchSizeRecommendationDisplayable({ commit, rootState }, { product_code }) {
    return rootState.api
      .fetchSizeRecommendationDisplayableCheck(product_code)
      .then(({ data }) => {
        commit('SET_SIZE_RECOMMENDATION_DISPLAYABLE', data.displayable);
      });
  }
};

export default { namespaced: true, state, mutations, actions };
